'use client';

import { CompanyUpdate, formatDate, getImageUrl } from '@repo/utils';
import ModalBasic from '../modal-basic';

interface CompanyUpdateModalProps {
  isOpen: boolean
  setIsOpen: (open: boolean) => void
  companyUpdate: CompanyUpdate
};

const ViewCompanyUpdateModal = ({ isOpen, setIsOpen, companyUpdate }: CompanyUpdateModalProps) => {
  const { name, message, updated } = companyUpdate;
  const image = companyUpdate.image?.key;

  return (
    <ModalBasic title="Company Update" isOpen={isOpen} setIsOpen={() => setIsOpen(false)}>
      <div className="w-full">
        <div className="flex flex-wrap justify-center items-center">
          <div className="w-full max-w-lg mx-auto bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
            {image && <img src={getImageUrl(image)} className="h-[240px] w-full object-cover mb-3" />}

            <div className="mb-5">
              <p className="text-lg font-semibold">{name}</p>
              <p className="text-sm">{message}</p>
            </div>

            <div className="flex items-center justify-between w-full">
              <p>{formatDate(updated?.toLocaleString() ?? '')}</p>
            </div>
          </div>
        </div>
      </div>
    </ModalBasic>
  );
};

export default ViewCompanyUpdateModal;
